import { render, staticRenderFns } from "./editLessonModal.vue?vue&type=template&id=3aafba15&"
import script from "./editLessonModal.vue?vue&type=script&lang=js&"
export * from "./editLessonModal.vue?vue&type=script&lang=js&"
import style0 from "./editLessonModal.vue?vue&type=style&index=0&id=3aafba15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports